module.exports = __webpack_public_path__ + "img/acceptance-logo.d5a3e3c2.png";